module.exports = __webpack_public_path__ + "img/reference-aurora.804ebf7c.webp";